module.exports = __webpack_public_path__ + "static/media/table_ace2ace.0e816f42.png";